import { useEffect, useState } from "react";

import DropDown from "../../Common/Forms/DropDown";
import DropDownListSearch from "../../Common/Forms/DropdownListSearchable";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDateTimePickerNative from "../../Common/Forms/FromToDateTimePickerNative";
import TextInput from "../../Common/Forms/TextInput";

import { visAlleJaNei } from "../../../constants/globals";

const MiljokontrollOversiktFilter = ({
  miljokontrollOversiktFilterForm,
  overtredelseskoder,
  getOvertredelseskodeParagraf,
  handleBlur,
  handleSubmit,
  handleChangeToInitState,
  getOvertredelseskoderMiljogebyr,
}) => {
  const [filterState, setFilterState] = useState(
    miljokontrollOversiktFilterForm,
  );
  const [showSpinnerState, setShowSpinnerState] = useState(false);
  const [validationErrorState, setValidationErrorState] = useState({
    fraDatoValidationErrorText: null,
    fraTidValidationErrorText: null,
    tilDatoValidationErrorText: null,
    tilTidValidationErrorText: null,
  });

  useEffect(() => {
    setFilterState(miljokontrollOversiktFilterForm);
  }, [miljokontrollOversiktFilterForm]);

  useEffect(() => {
    // overtredelseskoder.lenghth because at least "Velg" exists in the array
    if (overtredelseskoder.length === 1) {
      getOvertredelseskoderMiljogebyr();
    }
  }, [overtredelseskoder, getOvertredelseskoderMiljogebyr]);

  return (
    <form
      className="ileggelse-filter-container"
      onSubmit={(e) =>
        handleSubmit(
          e,
          filterState,
          validationErrorState,
          setValidationErrorState,
          setShowSpinnerState,
        )
      }
    >
      <h1>Søk etter tidskontroller</h1>
      <div className="filter-flexbox-container ettersendelse-filter-flexbox-item">
        <TextInput
          label="Ileggelsesnummer"
          name="ileggelsesnummer"
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
          onBlur={(e) => handleBlur(e, filterState, setFilterState)}
          value={filterState.ileggelsesnummer}
        />
        <FromToDateTimePickerNative
          from={{
            date: {
              id: "fraDato",
              name: "fraDato",
              label: "Dato fra",
              placeholder: "Velg",
              value: filterState.fraDato,
              validationError: validationErrorState.fraDatoValidationErrorText,
            },
            time: {
              id: "fraTid",
              name: "fraTid",
              label: "Tid fra",
              placeholder: "Velg",
              value: filterState.fraTid,
              validationError: validationErrorState.fraTidValidationErrorText,
            },
          }}
          to={{
            date: {
              id: "tilDato",
              name: "tilDato",
              label: "Dato til",
              placeholder: "Velg",
              value: filterState.tilDato,
              validationError: validationErrorState.tilDatoValidationErrorText,
            },
            time: {
              id: "tilTid",
              name: "tilTid",
              label: "Tid til",
              placeholder: "Velg",
              value: filterState.tilTid,
              validationError: validationErrorState.tilTidValidationErrorText,
            },
          }}
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
        />
        <TextInput
          label="Tjenestenummer"
          name="tjenestenummer"
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
          onBlur={(e) => handleBlur(e, filterState, setFilterState)}
          value={filterState.tjenestenummer}
        />
        <div>
          <DropDown
            id="hasMiljogebyrId"
            label="Knyttet til miljogebyr"
            name="hasMiljogebyrId"
            selected={filterState.hasMiljogebyrId}
            items={visAlleJaNei}
            title="Velg"
            onChange={(e) =>
              setFilterState({
                ...filterState,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>
        <div>
          <DropDown
            id="avsluttet"
            label="Lukket"
            name="avsluttet"
            selected={filterState.avsluttet}
            title="Velg"
            items={visAlleJaNei}
            onChange={(e) =>
              setFilterState({
                ...filterState,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>
        <TextInput
          label="Gatenavn/Ved"
          name="gatenavn"
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
          onBlur={(e) =>
            setFilterState({
              ...filterState,
              [e.target.name]: e.target.value.trim(),
            })
          }
          value={filterState.gatenavn}
        />
        <TextInput
          label="Gatenummer/Ved nr."
          name="gatenummer"
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
          onBlur={(e) =>
            setFilterState({
              ...filterState,
              [e.target.name]: e.target.value.trim(),
            })
          }
          value={filterState.gatenummer}
        />
        <TextInput
          label="Bydel"
          name="bydel"
          onChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
          onBlur={(e) =>
            setFilterState({
              ...filterState,
              [e.target.name]: e.target.value.trim(),
            })
          }
          value={filterState.bydel}
        />
        <DropDownListSearch
          label="Overtredelseskode"
          name="overtredelseskode"
          title={
            getOvertredelseskodeParagraf(filterState.overtredelseskode) ||
            "Velg"
          }
          items={overtredelseskoder}
          selected={filterState.overtredelseskode}
          handleChange={(e) =>
            setFilterState({ ...filterState, [e.target.name]: e.target.value })
          }
        />
      </div>
      <div style={{ marginTop: 10 }}>
        <FormButtonsForCloseAndSubmit
          closeText="Tilbakestill"
          submitText="Søk"
          onSubmit={() => {}}
          onClose={handleChangeToInitState}
          showCloseSpinner={false}
          showSubmitSpinner={showSpinnerState}
        />
      </div>
    </form>
  );
};

export default MiljokontrollOversiktFilter;
